import { Route, Switch } from "react-router-dom";
import PricingParityMsrpAppealsQueuePage from "@faire/prototype-playground/workspace/jg/pricing-parity-msrp-appeals-queue";
import PricingParityMsrpReviewAuditQueuePage from "@faire/prototype-playground/workspace/jg/pricing-parity-msrp-audit-queue";
import PricingParityMsrpInitialReviewAdminQueuePage from "@faire/prototype-playground/workspace/jg/pricing-parity-msrp-initial-review";
import PricingParityMsrpQaAdminQueuePage from "@faire/prototype-playground/workspace/jg/pricing-parity-msrp-qa";

export function JackGuoRoutes() {
  return (
    <Switch>
      <Route path="/jg/pricing-parity-msrp-appeals-queue" component={PricingParityMsrpAppealsQueuePage} />
      <Route path="/jg/pricing-parity-msrp-audit-queue" component={PricingParityMsrpReviewAuditQueuePage} />
      <Route path="/jg/pricing-parity-msrp-initial-review" component={PricingParityMsrpInitialReviewAdminQueuePage} />
      <Route path="/jg/pricing-parity-msrp-qa" component={PricingParityMsrpQaAdminQueuePage} />
    </Switch>
  );
}

export const slug = "jg";
